// import React from 'react';
// import ReactDOM from 'react-dom';
// import '../src/styles/global.scss';
// import {Card, Row, Col} from 'antd';

// import './index.scss';

// import App from './App'
// import Login from './pages/login';
// import GridLayout from './pages/layout/gridLayout';
// import FormElements from './pages/form/form-elements';
// import FormControls from './pages/form/form-controls';
// import FormComponents from './pages/form/form-components';
// import Affix from './pages/navigation/affix';
// import Dropdown from './pages/navigation/dropdown';
// import Menu from './pages/navigation/menu';
// import Pagination from './pages/navigation/pagination';
// import PageHeader from './pages/navigation/pageheader';
// import Steps from './pages/navigation/steps';
// import Buttons from './pages/components/buttons';
// import Typography from './pages/components/typography';
// import BasicCalendar from './pages/calendar/basic-calendar';
// import NoticeCalendar from './pages/calendar/notice-calendar';
// import SelectableCalendar from './pages/calendar/selectable-calendar';
// import List from './pages/data-display/list';
// import Tooltip from './pages/data-display/tooltip-popover';
// import Carousel from './pages/data-display/carousel';
// import Charts from './pages/charts';
// import Table from './pages/table';
// import ValidatePolicy from './ClaimCreation';
// import Claims from './Claims';
// import DocumentUploader from './DocumentUploader';
// import GenerateAssessorReport from './GenerateAssessorReport';
// import AuthoriseClaim from './AuthoriseClaim';
// import Documents from './pages/Documents/documentsList';
// import Home from './Home';
// import AuditTrial from './pages/Audit-trial';
// import InitiateClaim from './pages/InitiateClaim';
// import ApproveClaim from './pages/ClaimView';
// import {
//   Route,
//   Link,
//   Redirect,
//   Switch,
//   BrowserRouter as Router,
// } from 'react-router-dom';

// // ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA

// // serviceWorker.unregister();
// const NoMatchPage = () => {
//   return (
//     <Row style={{marginTop: '20%'}}>
//       <Col xs={{span: 12, offset: 6}}>
//         <Card>
//           <div className="card-body">
//             <div className="d-flex flex-column align-items-center justify-content-center">
//               <h2>Page not found</h2>
//               <Link to="/dashboard">back to dashboard</Link>
//             </div>
//           </div>
//         </Card>
//       </Col>
//     </Row>
//   )
// }
// const token = localStorage.getItem('token')

// const routing = (
//  <Router>
//     {localStorage.getItem('loggedInUserID') ? (
//       <Switch>
//         <Route exact path="/" component={Login} />
//         <Route exact path="/ClaimCreation" component={ValidatePolicy} />
//         <Route exact path="/EditClaim/:policyNumber" component={ValidatePolicy} />
//         <Route exact path="/home" component={Home} />
//         <Route exact path="/claims/:claimNumber?" component={Claims} />
//         <Route exact path="/audit-trial" component={AuditTrial} />
//         <Route exact path="/initiate-claim" component={InitiateClaim} />
//         <Route exact path="/approve-claim/:id/:policyNumber" component={ApproveClaim} />
//         <Route exact path="/upload-documents/:claimId/:claimNumber/:ProductId/:insurerId" component={Documents} />
//         <Route exact  path="/generateAssessor"  component={GenerateAssessorReport} />
//         <Route exact path="/documentUpload" component={DocumentUploader} />
//         <Route exact path="/authoriseClaim" component={AuthoriseClaim} />
//         <Route exact path="/layout/gridLayout" component={GridLayout} />
//         <Route exact path="/form/form-elements" component={FormElements} />
//         <Route exact path="/form/form-controls" component={FormControls} />
//         <Route exact path="/form/form-components" component={FormComponents} />
//         <Route exact path="/navigation/affix" component={Affix} />
//         <Route exact path="/navigation/dropdown" component={Dropdown} />
//         <Route exact path="/navigation/menu" component={Menu} />
//         <Route exact path="/navigation/pagination" component={Pagination} />
//         <Route exact path="/navigation/pageheader" component={PageHeader} />
//         <Route exact path="/navigation/steps" component={Steps} />
//         <Route exact path="/components/buttons" component={Buttons} />
//         <Route exact path="/components/typography" component={Typography} />
//         <Route exact path="/calendar/basic-calendar" component={BasicCalendar} />
//         <Route exact path="/calendar/notice-calendar" component={NoticeCalendar} />
//         <Route exact path="/calendar/selectable-calendar" component={SelectableCalendar} />
//         <Route exact path="/data-display/list" component={List} />
//         <Route exact path="/data-display/tooltip-popover" component={Tooltip} />
//         <Route exact path="/data-display/carousel" component={Carousel} />
//         <Route exact path="/charts" component={Charts} />
//         <Route exact path="/table" component={Table} />
//         <Route path="*" component={Login} />
//       </Switch>
//     ) : (
//       <Switch>
//         <Route path="*" component={Login} />
//       </Switch>
//     )}
//   </Router>
// )
// ReactDOM.render(routing, document.getElementById('root'))

import React from 'react';
import ReactDOM from 'react-dom';
import '../src/styles/global.scss';
import { Card, Row, Col } from 'antd';
import './index.scss';

import App from './App';

import Login from './pages/login';
import GridLayout from './pages/layout/gridLayout';
import FormElements from './pages/form/form-elements';
import FormControls from './pages/form/form-controls';
import FormComponents from './pages/form/form-components';
import Affix from './pages/navigation/affix';
import Dropdown from './pages/navigation/dropdown';
import Menu from './pages/navigation/menu';
import Pagination from './pages/navigation/pagination';
import PageHeader from './pages/navigation/pageheader';
import Steps from './pages/navigation/steps';
import Buttons from './pages/components/buttons';
import Typography from './pages/components/typography';
import BasicCalendar from './pages/calendar/basic-calendar';
import NoticeCalendar from './pages/calendar/notice-calendar';
import SelectableCalendar from './pages/calendar/selectable-calendar';
import List from './pages/data-display/list';
import Tooltip from './pages/data-display/tooltip-popover';
import Carousel from './pages/data-display/carousel';
import Charts from './pages/charts';
import Table from './pages/table';

import ValidatePolicy from './ClaimCreation';
import Claims from './Claims';
import DocumentUploader from './DocumentUploader';
import GenerateAssessorReport from './GenerateAssessorReport';
import AuthoriseClaim from './AuthoriseClaim';
import Documents from './pages/Documents/documentsList';
import Home from './Home';
import AuditTrial from './pages/Audit-trial';
import InitiateClaim from './pages/InitiateClaim';
import ApproveClaim from './pages/ClaimView';

import { Route, Redirect, Switch, BrowserRouter as Router, Link } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';   

// ---------------------------------
// 404 PAGE
// ---------------------------------
const NoMatchPage = () => {
  return (
    <Row style={{ marginTop: '20%' }}>
      <Col xs={{ span: 12, offset: 6 }}>
        <Card>
          <div className="card-body">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <h2>Page not found</h2>
              <Link to="/home">Back to Home</Link>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

// ---------------------------------
// ROUTING
// ---------------------------------

const routing = (
  <Router>
    <Switch>

      {/* PUBLIC ROUTE */}
      <Route exact path="/" component={Login} />

      {/* PROTECTED ROUTES */}
      <PrivateRoute exact path="/ClaimCreation" component={ValidatePolicy} />
      <PrivateRoute exact path="/EditClaim/:policyNumber" component={ValidatePolicy} />
      <PrivateRoute exact path="/home" component={Home} />
      <PrivateRoute exact path="/claims/:claimNumber?" component={Claims} />
      <PrivateRoute exact path="/audit-trial" component={AuditTrial} />
      <PrivateRoute exact path="/initiate-claim" component={InitiateClaim} />
      <PrivateRoute exact path="/approve-claim/:id/:policyNumber" component={ApproveClaim} />
      <PrivateRoute exact path="/upload-documents/:claimId/:claimNumber/:ProductId/:insurerId" component={Documents} />
      <PrivateRoute exact path="/generateAssessor" component={GenerateAssessorReport} />
      <PrivateRoute exact path="/documentUpload" component={DocumentUploader} />
      <PrivateRoute exact path="/authoriseClaim" component={AuthoriseClaim} />

      {/* UI Pages */}
      <PrivateRoute exact path="/layout/gridLayout" component={GridLayout} />
      <PrivateRoute exact path="/form/form-elements" component={FormElements} />
      <PrivateRoute exact path="/form/form-controls" component={FormControls} />
      <PrivateRoute exact path="/form/form-components" component={FormComponents} />
      <PrivateRoute exact path="/navigation/affix" component={Affix} />
      <PrivateRoute exact path="/navigation/dropdown" component={Dropdown} />
      <PrivateRoute exact path="/navigation/menu" component={Menu} />
      <PrivateRoute exact path="/navigation/pagination" component={Pagination} />
      <PrivateRoute exact path="/navigation/pageheader" component={PageHeader} />
      <PrivateRoute exact path="/navigation/steps" component={Steps} />
      <PrivateRoute exact path="/components/buttons" component={Buttons} />
      <PrivateRoute exact path="/components/typography" component={Typography} />
      <PrivateRoute exact path="/calendar/basic-calendar" component={BasicCalendar} />
      <PrivateRoute exact path="/calendar/notice-calendar" component={NoticeCalendar} />
      <PrivateRoute exact path="/calendar/selectable-calendar" component={SelectableCalendar} />
      <PrivateRoute exact path="/data-display/list" component={List} />
      <PrivateRoute exact path="/data-display/tooltip-popover" component={Tooltip} />
      <PrivateRoute exact path="/data-display/carousel" component={Carousel} />
      <PrivateRoute exact path="/charts" component={Charts} />
      <PrivateRoute exact path="/table" component={Table} />

      {/* FALLBACK */}
      <Route path="*" component={NoMatchPage} />
    </Switch>
  </Router>
);

ReactDOM.render(routing, document.getElementById('root'));

